export default function formatDecimalNumber(value: number, maxDecimals: number = 4): string {
    var valueWithDecimals = parseFloat(value.toFixed(4)).toString();
    var formattedNumber = valueWithDecimals.replace(".", ",");
    return formattedNumber;
}